"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Those are the BestPrice legacy breakpoint system.
exports.default = ['TINY', 'XXSM', 'XSM', 'SM', 'MD_FILTERS_ONLY', 'MD', 'LG', 'XL', 'XL_PRODUCTS', 'XXL', 'XXXL', 'XXXXL'];
